import React, { useState } from 'react';
import styled from 'styled-components';
import { strings } from './strings';

const Header = styled.header`
  background-color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 50;
  direction: rtl;
`;

const HeaderContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
  @media (min-width: 640px) {
    padding: 0 1.5rem;
  }
  @media (min-width: 1024px) {
    padding: 0 2rem;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
`;

const LogoIcon = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  background: linear-gradient(to right, #ea580c, #f97316);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoText = styled.span`
  margin-right: 0.75rem;
  font-size: 1.5rem;
  font-weight: bold;
  color: #111827;
`;

const DesktopNav = styled.nav`
  display: none;
  gap: 1.5rem;
  
  @media (min-width: 768px) {
    display: flex;
  }
`;

const NavButton = styled.button`
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.975rem;
  font-weight: 800;
  transition: all 0.2s;
  border: none;
  cursor: pointer;
  position: relative;
  background-color: ${props => props.active ? '#fff7ed' : 'transparent'};
  color: ${props => props.active ? '#ea580c' : '#374151'};
  ${props => props.special && `
    background: linear-gradient(45deg, #ea580c, #f97316);
    color: white;
    font-weight: 600;
    
    &::before {
      content: "🎁";
      margin-left: 0.5rem;
    }
    
    &:hover {
      background: linear-gradient(45deg, #c2410c, #ea580c);
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(234, 88, 12, 0.3);
    }
  `}
  
  &:hover {
    color: ${props => props.special ? 'white' : '#ea580c'};
    background-color: ${props => props.special ? 'inherit' : '#fff7ed'};
  }
`;

const MobileMenuButton = styled.button`
  display: block;
  padding: 0.5rem;
  border-radius: 0.375rem;
  color: #374151;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.2s;
  
  &:hover {
    color: #ea580c;
  }
  
  @media (min-width: 768px) {
    display: none;
  }
`;

const MobileMenu = styled.div`
  display: ${props => props.isOpen ? 'block' : 'none'};
  padding: 1rem 0;
  border-top: 1px solid #e5e7eb;
  
  @media (min-width: 768px) {
    display: none;
  }
`;

const MobileNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const MobileNavButton = styled.button`
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: right;
  transition: all 0.2s;
  border: none;
  cursor: pointer;
  background-color: ${props => props.active ? '#fff7ed' : 'transparent'};
  color: ${props => props.active ? '#ea580c' : '#374151'};
  ${props => props.special && `
    background: linear-gradient(45deg, #ea580c, #f97316);
    color: white;
    font-weight: 600;
    
    &::after {
      content: " 🎁";
    }
  `}
  
  &:hover {
    color: ${props => props.special ? 'white' : '#ea580c'};
    background-color: ${props => props.special ? 'inherit' : '#fff7ed'};
  }
`;

// Header Component
const HeaderComponent = ({ currentPage, setCurrentPage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { id: 'home', label: 'דף הבית' },
    { id: 'free-gifts', label: 'מתנות בחינם', special: true },
    { id: 'process', label: 'על התהליך' },
    { id: 'podcast', label: 'פודקאסט' },
    { id: 'contact', label: 'צור קשר' }
  ];

  return (
    <Header>
      <HeaderContainer>
        <HeaderContent>
          <Logo>
            <LogoIcon>
              <span style={{ color: 'white', fontWeight: 'bold', fontSize: '1.25rem' }}>F</span>
            </LogoIcon>
            <LogoText>{strings.global.businessName}</LogoText>
          </Logo>

          <DesktopNav>
            {navItems.map((item) => (
              <NavButton
                key={item.id}
                active={currentPage === item.id}
                special={item.special}
                onClick={() => setCurrentPage(item.id)}
              >
                {item.label}
              </NavButton>
            ))}
          </DesktopNav>

          <MobileMenuButton onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <span style={{ fontSize: '1.5rem' }}>✕</span> : <span style={{ fontSize: '1.5rem' }}>☰</span>}
          </MobileMenuButton>
        </HeaderContent>

        <MobileMenu isOpen={isMenuOpen}>
          <MobileNav>
            {navItems.map((item) => (
              <MobileNavButton
                key={item.id}
                active={currentPage === item.id}
                special={item.special}
                onClick={() => {
                  setCurrentPage(item.id);
                  setIsMenuOpen(false);
                }}
              >
                {item.label}
              </MobileNavButton>
            ))}
          </MobileNav>
        </MobileMenu>
      </HeaderContainer>
    </Header>
  );
};

export default HeaderComponent;